

class ProductCarouselSlider extends HTMLElement {
  connectedCallback() {
    const container = this.querySelector(".swiper");

    if (!container) return;

    const prevEl = this.querySelector("[data-navigation-previous]");
    const nextEl = this.querySelector("[data-navigation-next]");

    window.loadSwiper.then(({ Swiper, Navigation }) => {
      if (this.swiper) return;

      const modules = [Navigation];
      const swiperParams = {
        modules,
        spaceBetween: 16,
        slidesPerView: 1.2,
        observer: true,
        observeParents: true,
        navigation: prevEl && nextEl ? { prevEl, nextEl } : undefined,
        breakpoints: {
          [window.themeBreakpoints.tablet]: {
            slidesPerView: 2.7,
            spaceBetween: 24,
          },
          [window.themeBreakpoints["tablet-wide"]]: {
            slidesPerView: 3.3,
            spaceBetween: 24,
          },
          [window.themeBreakpoints["desktop"]]: {
            slidesPerView: 4.3,
            spaceBetween: 24,
          },
        },
      };
      this.swiper = new Swiper(container, swiperParams);
    });
  }

  disconnectedCallback() {
    this.swiper?.destroy(true, true);
    this.swiper = null;
  }
}

if (!customElements.get("product-carousel-slider")) {
  customElements.define("product-carousel-slider", ProductCarouselSlider);
}
